function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeaderboardBadge = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _View = require("../../../View");
var Icons = _interopRequireWildcard(require("../../../Icons"));
var _styles2 = require("../../../../styles");
var _reactNative = require("react-native-web");
var _reactI18next = require("react-i18next");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var LeaderboardBadge = exports.LeaderboardBadge = (0, _react.memo)(function (_ref) {
  var value = _ref.value,
    type = _ref.type;
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var isPositiveValue = value > 0;
  var _STYLES$useStyles = _styles2.STYLES.useStyles(),
    colors = _STYLES$useStyles.colors;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return (0, _jsxRuntime.jsxs)(_View.View, {
    testID: "LeaderboardBadge",
    style: [styles.badge, isPositiveValue ? styles.positiveBadge : styles.negativeBadge],
    children: [(0, _jsxRuntime.jsx)(_reactNative.Text, {
      style: [styles.badgeText, isPositiveValue ? styles.badgeTextPositive : styles.badgeTextNegative],
      children: t('format:number', {
        value: value
      })
    }), type && type === 'trying' ? isPositiveValue ? (0, _jsxRuntime.jsx)(_View.View, {
      style: styles.badgeIconWrapperPositive,
      testID: "LeaderboardBadgeTryingPositive",
      children: (0, _jsxRuntime.jsx)(Icons.ThumbUpOutline, {
        style: styles.badgeIcon,
        size: (0, _styles2.getREM)(1),
        color: colors.positive,
        title: "thumb up icon"
      })
    }) : (0, _jsxRuntime.jsx)(_View.View, {
      style: styles.badgeIconWrapperNegative,
      testID: "LeaderboardBadgeTryingNegative",
      children: (0, _jsxRuntime.jsx)(Icons.ThumbUpOutline, {
        style: [styles.badgeIcon, styles.badgeIconReversed],
        size: (0, _styles2.getREM)(1),
        color: colors.negative,
        title: "thumb down icon"
      })
    }) : isPositiveValue ? (0, _jsxRuntime.jsx)(_View.View, {
      style: styles.badgeIconWrapperPositive,
      testID: "LeaderboardBadgeCompletedPositive",
      children: (0, _jsxRuntime.jsx)(Icons.TickRosetteOutline, {
        style: styles.badgeIcon,
        size: (0, _styles2.getREM)(1),
        color: colors.positive
      })
    }) : (0, _jsxRuntime.jsx)(_View.View, {
      style: styles.badgeIconWrapperNegative,
      testID: "LeaderboardBadgeCompletedNegative",
      children: (0, _jsxRuntime.jsx)(Icons.TickRosetteOutline, {
        style: styles.badgeIcon,
        size: (0, _styles2.getREM)(1),
        color: colors.negative
      })
    })]
  });
});